import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import { Redirect, Switch } from 'react-router'
import Landing from 'scenes/Games/Landing'

const Games = () => {
  const gamesFeatureEnabled = useFlag('gamification-management-enabled', false)

  if (!gamesFeatureEnabled) {
    return <Redirect to="/" />
  }

  return (
    <div className="full-height grey-05-bkg">
      <Switch>
        <ProtectedRoute
          redirect="/"
          resource="Games"
          exact
          path="/games"
          component={Landing}
        />
      </Switch>
    </div>
  )
}

export default Games
